import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-lg-20 w-sm-100",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = {
  class: "text-truncate",
  style: {"max-width":"120px"}
}
const _hoisted_8 = { class: "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2" }
const _hoisted_9 = {
  class: "fw-bold text-muted text-hover-primary fs-7 text-truncate",
  style: {"max-width":"160px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_11 = { class: "menu-item px-5" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" My Profile ")
const _hoisted_13 = { class: "menu-item px-5" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Manage Users ")
const _hoisted_15 = { class: "menu-item px-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_18 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Avatar, { image: _ctx.image }, null, 8, ["image"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userName), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userSubscription), 1)
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.userRoles), 1)
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: "/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_router_link, {
        to: "/settings/users",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_router_link, {
        to: "/settings",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      })
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}